/**
 * Edit-user: business-error mapper.
 *
 * Reuses the shared `UserFormError` union (identity field map) but pins the
 * Edit-flow default message ("Failed to update user."). The `validation` variant
 * is produced by the saga directly; this maps the infra failures
 * (`network` | `api`) for load / update.
 */
import { classifyInfraError } from '@/utils/infra-error';

import type { UserFormError } from '../../_shared/domain/user-form-error';

export type EditUserError = UserFormError;

export function toEditUserError(e: unknown): EditUserError {
  return classifyInfraError(e, 'Failed to update user.');
}
